import dayjs, { type Dayjs } from "dayjs";

export const SHIFT_TYPES = ["kunduzgi", "tungi"] as const;
export type ShiftType = (typeof SHIFT_TYPES)[number];

export const PATTERN_KINDS = ["weekly", "cyclic"] as const;
export type PatternKind = (typeof PATTERN_KINDS)[number];

/**
 * ⚠️ Bu fayl matn saqlamaydi (P7 spec §8) — ko'rinadigan yorliq
 * `useTranslation("schedules")` bilan `t(\`shiftType.${value}\`)` /
 * `t(\`patternKind.${value}\`)` / `t(\`weekday.${value}\`)` /
 * `t(\`weekdayShort.${value}\`)` orqali olinadi. Bu yerda faqat qiymatlar
 * tartibi (Select opsiyalari uchun) saqlanadi.
 */
/** Dushanba = 1 (`schedules.schemas.ts` dagi `weekdaysSchema`). */
export const WEEKDAY_VALUES = [1, 2, 3, 4, 5, 6, 7] as const;

export interface Schedule {
	id: string;
	name: string;
	shiftType: ShiftType;
	patternKind: PatternKind;
	weekdays: number[] | null;
	cycleDays: number | null;
	workDays: number | null;
	/** "YYYY-MM-DD". */
	anchorDate: string | null;
	/** "HH:MM:SS". */
	startTime: string;
	endTime: string;
	lunchStart: string | null;
	lunchEnd: string | null;
	crossesMidnight: boolean;
	isActive: boolean;
}

export interface ScheduleInput {
	name: string;
	shiftType: ShiftType;
	patternKind: PatternKind;
	weekdays?: number[] | null;
	cycleDays?: number | null;
	workDays?: number | null;
	anchorDate?: string | null;
	startTime: string;
	endTime: string;
	lunchStart?: string | null;
	lunchEnd?: string | null;
	crossesMidnight: boolean;
}

export interface ScheduleFormValues {
	name: string;
	shiftType: ShiftType;
	patternKind: PatternKind;
	weekdays?: number[];
	cycleDays?: number;
	workDays?: number;
	anchorDate?: Dayjs;
	startTime: Dayjs;
	endTime: Dayjs;
	lunchStart?: Dayjs;
	lunchEnd?: Dayjs;
	crossesMidnight?: boolean;
}

/** Xodim YOKI bo'lim — ikkalasi emas (`schedule_assignments` CHECK cheklovi). */
export interface ScheduleAssignment {
	id: string;
	scheduleId: string;
	employeeId: string | null;
	departmentId: string | null;
	validFrom: string;
	validTo: string | null;
}

export interface ScheduleAssignInput {
	scheduleId: string;
	employeeId?: string | null;
	departmentId?: string | null;
	validFrom: string;
	validTo?: string | null;
}

export type AssignmentTarget = "employee" | "department";

export interface AssignmentFormValues {
	target: AssignmentTarget;
	employeeId?: string;
	departmentId?: string;
	validFrom: Dayjs;
	validTo?: Dayjs;
}

export interface Holiday {
	id: string;
	/** "YYYY-MM-DD". */
	sana: string;
	nom: string;
	tur: string | null;
	/** `true` — dam olish kunida ISHLANADI (override). */
	isWorkday: boolean;
}

export interface HolidayInput {
	sana: string;
	nom: string;
	tur?: string | null;
	isWorkday: boolean;
}

export interface HolidayFormValues {
	sana: Dayjs;
	nom: string;
	tur?: string;
	isWorkday?: boolean;
}

export interface ShiftInstance {
	id: string;
	employeeId: string;
	scheduleId: string;
	workDate: string;
	/** ISO 8601 timestamptz. */
	plannedStartAt: string;
	plannedEndAt: string;
}

/**
 * "HH:MM:SS" → `Dayjs`.
 *
 * `dayjs("09:00:00")` YAROQSIZ obyekt beradi (format plagini yo'q), shuning
 * uchun sana qo'shib to'liq ISO qatoriga aylantiriladi. Sananing o'zi
 * ahamiyatsiz — faqat vaqt qismi ishlatiladi.
 */
export function timeToDayjs(value: string): Dayjs {
	return dayjs(`1970-01-01T${value}`);
}
